import { Color, Spacing } from '@persona-id/design-tokens';
import { CircleXIcon } from '@persona-id/design-tokens/icons';
import { isEmpty } from 'lodash/fp';
import { ReactNode } from 'react';
import styled from 'styled-components';

import Accordion from 'dashboard/components/Accordion';
import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import AccordionInline from 'dashboard/components-lib/AccordionInline';
import { formatDate } from 'dashboard/lib/utils/formatters';
import { ReportSecActionLookup } from 'dashboard/models/report/sec-action-lookup';
import Spacer from 'design-system/components/Spacer';
import { Label, Paragraph, Span } from 'design-system/components/Text';

const MatchAccordionHeader = styled('div')`
  display: flex;
  align-items: center;
`;

const MatchContents = styled('div')`
  padding-left: ${Spacing[5]};
`;

interface SecActionLookupProps {
  report: ReportSecActionLookup;
  isRedacted: boolean;
}

export default ({ report }: SecActionLookupProps) => {
  const { result: result } = report.attributes;
  if (isEmpty(result)) {
    return null;
  }

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const displayResult = result.map((secActionLookupMatch, matchIdx): ReactNode => {
    return (
      <Accordion
        menuItem={true}
        padded={false}
        key={matchIdx}
        title={
          <MatchAccordionHeader>
            <CircleXIcon color={Color.BorderIconDanger} />
            <Spacer width={1} />
            <Label size='lg' weight='bold'>
              {secActionLookupMatch['name-full']}
            </Label>
            <Spacer width={3} />
            <Paragraph color='tertiary'>
              {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
              Age: {secActionLookupMatch['age-range'].join(' - ')}
            </Paragraph>
            <Spacer width={3} />
            <Paragraph color='tertiary'>{secActionLookupMatch['address-subdivision']}</Paragraph>
          </MatchAccordionHeader>
        }
      >
        <MatchContents>
          <Spacer height={3} />
          <AttributeGrid>
            <AttributeItem
              title='Enforcement Action'
              value={secActionLookupMatch['enforcement-action']}
            />
            <AttributeItem
              title='Date'
              value={formatDate(secActionLookupMatch['enforcement-action-date'])}
            />
          </AttributeGrid>

          <Spacer height={3} />

          <AccordionInline
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            title={`Releases & Documents (${secActionLookupMatch['releases-and-documents'].length})`}
          >
            {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
            {secActionLookupMatch['releases-and-documents'].map(
              (release, releaseIdx): ReactNode => (
                <Paragraph key={releaseIdx}>
                  <a href={release.url} target='_blank' rel='noreferrer'>
                    {release.title}
                  </a>{' '}
                  <Span color='tertiary'>({formatDate(release.date)})</Span>
                </Paragraph>
              ),
            )}
          </AccordionInline>
          <Spacer height={3} />
        </MatchContents>
      </Accordion>
    );
  });

  return <div>{displayResult}</div>;
};
